<template>
	<el-form ref="form" :model="attachments" :rules="validation_rules" label-position="top" id="attachments" class="note-card">
		<h1>Attachments</h1>
		<p style="text-align:center;margin-bottom:30px;">Click the "i" icons on the left-hand side for instructions and/or resources. <br>Images <u>must</u> be in <strong><u>jpeg/jpg</u></strong> format, and all <u>other</u> attachments in <strong><u>PDF</u></strong> format.</p>
		<div class="attachment-container" v-for="item in items" :key="item.name">

			<upload-image v-if="item.isImg" v-on:show-modal="showModal" v-on:validation-needed="validateField" :item="item"/>
			<upload-non-image v-on:show-modal="showModal" v-on:validation-needed="validateField" v-else :item="item"/>
			<hr>
		</div>

		<el-dialog
		title=""
		:visible.sync="centerDialogVisible"
		width="30%"
		center>
		<p v-html="this.iObj.instructionalTxt"></p>
	</el-dialog>

</el-form>
</template>

<script>
import { mapState } from 'vuex';
import { mapSimpleArrayValidation } from '@/js/utilities/validation-mapper.js';
import validation_mixin from '@/js/mixins/validation-mixin.js';
export default{
	mixins: [validation_mixin],
	computed: {
		...mapState('application/attachments', {
			attachments: state => state
		})
	},
	methods: {
		showModal(itemObj){
			if(itemObj.instructionalTxt != ''){
				this.iObj = itemObj;
				this.centerDialogVisible = true;
			}
		},
		validateField(field){
			this.$refs.form.validateField(field);
		}
	},
	data: function(){
		return {
			centerDialogVisible: false,
			iObj:Object,
			validation_rules: {
				...mapSimpleArrayValidation([
					'area_maps', 'plats', 'photos', 'appraisals', 'landowner_letters', 'adjacent_landowner_letters', 'support_letters', 'non_profit_documentation', 'landowner_disclosures'
				])
			},
			items: [
				{name:'Area Map', category: 'area_maps', isImg: false,
				isExternal:true,
				resourceWord:'GIS Viewer',
				resourceLink:'https://gisccweb.charlestoncounty.org/Public_Search/',
				instructionalTxt: ''},

				{name:'Plat', category: 'plats', isImg: false,
				isExternal:true,
				resourceWord:'ROD Search',
				resourceLink:'https://www.charlestoncounty.org/departments/rod/ds-DMNameandDateSearch.php',
				instructionalTxt: ''},

				{name:'Photos', category: 'photos', isImg: true,
				isExternal:false,
				resourceWord:'',
				resourceLink:'',
				hintTxt:'(JPEG format)',
				instructionalTxt: 'Upload a maximum of 20 photos in JPEG format'},

				{name:'Landowner Letter', category: 'landowner_letters', isImg: false,
				isExternal:false,
				resourceWord: 'Sample Letter',
				resourceLink:`${process.env.VUE_APP_SITE_PATH}/instructions/landowner-letter.docx`,
				instructionalTxt: ''},

				{name:'Adjacent Landowner Letters', category: 'adjacent_landowner_letters', isImg: false,
				isExternal:false,
				resourceWord:'',
				resourceLink:`${process.env.VUE_APP_SITE_PATH}/instructions/adjacent-landowner-letter.docx`,
				instructionalTxt: ''},

				{name:'Support Letters', category: 'support_letters', isImg: false,
				isExternal:false,
				resourceWord:'',
				resourceLink:'',
				instructionalTxt: 'Attach copies of letters/emails of support for the project. If a public hearing was held regarding the project, provide the results of the hearing (record of comments).'},

				{name:'Municipal Endorsement', category: 'municipal_endorsements', isImg: false,
				isExternal:false,
				resourceWord:'',
				resourceLink:'',
				instructionalTxt: 'Attach or insert a letter or resolution from the municipality endorsing this project, if applicable'},

				{name:'Master Plan', category: 'master_plans', isImg: false,
				isExternal:false,
				resourceWord:'',
				resourceLink:'',
				instructionalTxt: 'Attach or insert a copy of the project’s master plan, if applicable.'},

				{name:'Landowner Disclosure', category: 'landowner_disclosures', isImg: false,
				isExternal:false,
				resourceWord:'Template',
				resourceLink: `${process.env.VUE_APP_SITE_PATH}/instructions/landowner-disclosure.pdf`,
				instructionalTxt: ''},

				{name:'Other', category: 'other', isImg: false,
				isExternal: false,
				resourceWord:'',
				resourceLink:'',
				instructionalTxt: 'Attach other relevant documents here.'}

				// **If external link is blank, additional text will be shown in modal
			]
		}
	}}
	</script>

	<style scoped>
	.attachment-container {
		border-top: 1px solid #DCDFE6;
		padding: 10px 0;
	}
	.attachment-container >>> .el-upload-list__item.is-success .el-upload-list__item-status-label {
		padding: 15px;
	}
	.attachment-container >>> .el-upload.el-upload--text .el-upload-dragger {
		width: 100%;
	}
	.attachment-container > div {
		max-width: 760px;
		margin: 0 auto;
	}

	.attachment-container:last-child {
		border-bottom: 1px solid #DCDFE6;
	}

	#attachments >>> .attachment-title {
		cursor: pointer;
		color: #606266;
		transition: all 0.2s;
	}
	#attachments >>> .attachment-title a {
		text-decoration: none;
		color: #606266;
		transition: all 0.2s;
	}
	#attachments .attachment-container:hover .attachment-title, #attachments .attachment-container:hover >>> .attachment-title a {
		color: #409EFF !important;
		text-decoration: underline;
	}
	#attachments h3 {
		font-size: 1.5rem;
		background-color: #EBEEF5;
		padding: 10px 15px;
		font-weight: 300;
		border-radius: 8px;
		margin-bottom: 25px;
	}
	#attachments .attachment-header {
		display: flex;
		justify-content: center;
		line-height: 40px;
	}
	#attachments >>> .upload-demo > h2 {
		margin: 0;
		padding-top: 0;
		font-size: 2rem;
		text-align: left;
		margin-top: 0px;
		line-height: 40px;
		display: inline-block;
		width: 300px;
		width: fit-content;
		float: left;
	}
	#attachments >>> .upload-demo .el-upload {
		float: right;
		margin-top: 5px;
		margin-bottom: 5px;
	}
	#attachments >>> .upload-demo .el-button {
		padding: 10px 12px;
	}
	#attachments >>> .upload-demo ul {
		clear: both;
	}
	#attachments >>> .el-upload-dragger {
		border: none;
		height: auto;
	}
	#attachments >>> .btnUpload i {
		margin-right: 5px;
	}
	#attachments hr {
		display: none;
	}
	#attachments >>> .el-upload--picture-card, #attachments >>> .el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
		line-height: 80px;
	}
	#attachments >>> .el-upload-list__item.is-success .el-upload-list__item-status-label {
		display: none;
	}
	#attachments >>> .el-upload--picture-card i.el-icon-plus {
		font-size: 15px;
	}
	#attachments >>> .el-form-item .el-form-item__error{
		position: absolute;
		right: 65px !important;
		top: 25%;
		transform: translate(-50%);
	}
	</style>
